import { render, staticRenderFns } from "./ResetPasswords.vue?vue&type=template&id=63c3e53f&"
import script from "./ResetPasswords.vue?vue&type=script&lang=js&"
export * from "./ResetPasswords.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports